import PropTypes from "prop-types";
import {hasAnyRole} from "../shared/keycloak";
import AcessoNegado from "./error/AcessoNegado";

function RoleGate({roles, children}) {
    return hasAnyRole(...roles) ? children : <AcessoNegado />;
}

RoleGate.propTypes = {
    roles: PropTypes.arrayOf(PropTypes.string).isRequired,
    children: PropTypes.node.isRequired
};

export default RoleGate;
